import Heading from 'molecules/Heading';
import Icon from 'molecules/Icon';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import Reveal from 'components/Animations/Reveal';

import { hasArrayValues } from 'utils/array/arrays';

import type { EventExperienceConfigProps } from 'components/EventExperience/config';
import type { FC } from 'react';

const EventExperience: FC<EventExperienceConfigProps> = props => {
  const {
    sectionProps,
    rest: { heading, items },
  } = splitSectionProps(props);

  return (
    <Section {...sectionProps}>
      <div className="flex flex-col items-start gap-10 sm:items-center sm:gap-14">
        {heading && <Heading {...heading} alignment="center" />}

        {hasArrayValues(items) && (
          <div className="flex flex-wrap place-content-start gap-5 sm:justify-center">
            {items.map((item, index) => (
              <Reveal
                key={item.id ?? `item-${index}`}
                delay={index * 0.05}
                className="flex w-full items-center justify-center gap-6 rounded-lg border border-primary-1000 px-5 py-2.5 backdrop-blur-sm sm:w-80 lg:w-96"
              >
                {item.icon && <Icon icon={item.icon} iconColor="text-primary-300" size={24} />}
                <span className="font-roboto text-xl leading-9 text-primary-300">{item.label}</span>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </Section>
  );
};

export default EventExperience;
